<script setup lang="ts">
import { computed } from 'vue';
import { useQuasar } from 'quasar';
import { useRoute } from 'vue-router';
import logo from '@/assets/gleim_aviation_logo.svg';
import smallLogo from '@/assets/gleim_aviation_logo_small.svg';
import { availableParts } from '@/types/Certificate';
import { usePartStore } from '@/stores/part';

const $q = useQuasar();

// TODO: Find a better way to determine the breakpoint for the logo
const logoCutOffSize = 475;

const route = useRoute();
const pageTitle = computed(() => {
    const partStore = usePartStore();
    const part = Number(route.params.part) || partStore.getPart();

    if (route.meta.adminCenter) {
        return 'Admin Center';
    }
    if (part && availableParts.includes(part)) {
        return `${part}`;
    }
    return route.meta.displayName ?? '';
});
</script>
<template>
    <div
        id="fsum-logo-box"
        class="vertical-top"
    >
        <img
            id="gleim-av-logo"
            :src="$q.screen.width >= logoCutOffSize ? logo : smallLogo"
            :class="$q.screen.width >= logoCutOffSize ? 'full-logo' : 'small-logo'"
            alt="Gleim Aviation Logo"
        >
        <q-separator
            v-if="pageTitle"
            vertical
            class="q-mr-sm"
        />
        <div class="logo-box-text">
            {{ pageTitle }}
        </div>
    </div>
</template>
<style scoped lang="scss">
#fsum-menu-box, #fsum-logo-box {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: var(--fsum-header-height);

    #gleim-av-logo {
        margin-bottom: 5px;

        &.full-logo {
            height: 40px;
        }
        &.small-logo {
            height: 23px;
            padding-right: 16px;
            padding-left: 12px;
        }
    }
    :deep(.q-separator), :deep(.q-separator--vertical) {
        height: 23px;
        background: var(--fsum-black);
        align-self: center;
    }
    .logo-box-text {
        font-size: 20px;
        font-weight: 500;
        color: var(--fsum-black);
    }
}
#fsum-menu-box {
    width: var(--fsum-header-height);
}
</style>
